import React, { useEffect, ReactNode } from 'react';

interface ModalProps {
  /** Виден ли модал */
  isOpen: boolean;
  /** Закрыть модал */
  onClose: () => void;
  children: ReactNode;
  /** Дополнительный CSS-класс для .modal-box */
  className?: string;
  /** Минимальная ширина, напр. '600px' */
  minWidth?: string;
  /** Максимальная ширина, напр. '800px' */
  maxWidth?: string;
}

/**
 * Базовый модальный компонент.
 * Закрывается по клику на оверлей и по Escape.
 */
const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className = '',
  minWidth,
  maxWidth = '800px',
}) => {
  // Закрытие по Escape
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);

  // Блокируем скролл страницы под модалом
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal-box ${className}`}
        style={{ maxWidth, minWidth }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="modal-close-btn"
          onClick={onClose}
          aria-label="Закрыть"
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
